document.addEventListener("DOMContentLoaded", function () {
	const headerSection = document.querySelector(
		".section-header.shopify-section-header-sticky"
	);

	if (headerSection?.parentElement) {
		const lang = document.documentElement.lang; // Get the lang attribute from <html>
		let isHomePage = false;

		if (
			lang === "en" ||
			lang === "he" ||
			lang === "he-IL"
		) {
			isHomePage =
				window.location.pathname === "/" ||
				window.location.pathname === "/index";
		}

		headerSection.parentElement.classList.add(
			isHomePage
				? "transparent-header"
				: "not-transparent-header"
		);
	}

	document
		.getElementById("open_contact_us_drawer")
		.addEventListener("click", function () {
			document
				.querySelector(".contact-us-drawer_wrapper")
				.classList.add("active");
			document.body.classList.add("overflow-hidden");
		});

	document
		.getElementById("contact-us-drawer-Overlay")
		.addEventListener("click", function (event) {
			document
				.querySelector(".contact-us-drawer_wrapper")
				.classList.remove("active");
			document.body.classList.remove(
				"overflow-hidden"
			);
		});

	document
		.querySelector(
			".contact-us-drawer_wrapper .drawer__close"
		)
		.addEventListener("click", function (event) {
			document
				.querySelector(".contact-us-drawer_wrapper")
				.classList.remove("active");
			document.body.classList.remove(
				"overflow-hidden"
			);
		});

	// Prevent click inside the drawer from closing it
	document
		.querySelector(".drawer__inner")
		.addEventListener("click", function (event) {
			event.stopPropagation();
		});

	const header = document.querySelector(
		".shopify-section-header-sticky"
	);

	if (header) {
		window.addEventListener("scroll", function () {
			if (window.scrollY > 50) {
				header.classList.add(
					"scrolled-past-header"
				);
			} else {
				header.classList.remove(
					"scrolled-past-header"
				);
			}
		});
	}

    document.querySelector('.menu-drawer-container summary').addEventListener('click', function(event) {
        const navigationContainer =
					document.querySelector(
						".menu-drawer__navigation-container"
					);

        navigationContainer.classList.remove(
            "second_level",
            "third_level"
        );
    });

	const menuItems = document.querySelectorAll(
		".custom-header .menu-drawer-container .menu-drawer__menu-item, .custom-header .menu-drawer-container .menu-drawer__close-button"
	);

	menuItems.forEach((item) => {
		item.addEventListener("click", () => {

			setTimeout(function () {
				const submenuCount =
					document.querySelectorAll(
						".submenu-open"
					).length;

				const navigationContainer =
					document.querySelector(
						".menu-drawer__navigation-container"
					);

				if (submenuCount === 1) {
					navigationContainer.classList.add(
						"second_level"
					);
					navigationContainer.classList.remove(
						"third_level"
					);
				} else if (submenuCount > 1) {
					
                    navigationContainer.classList.add(
                        "third_level"
                    );

                    // navigationContainer.classList.remove(
					// 	"second_level"
					// );
				}
                else
                {
                    navigationContainer.classList.remove(
						"second_level",
						"third_level"
					);
                }
			}, 100);
		});
	});
});
